import { Component, ViewChild, ElementRef , HostListener, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { projectConstants } from '../../../shared/constants/project-constants';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { UnverifiedAccountService } from 'src/app/services/unverified-account.service';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-unverified-view',
  templateUrl: './unverified-view.component.html',
  styleUrls: ['./unverified-view.component.css']
})
export class UnverifiedViewComponent {
  tableFilters = '';
  displayedColumns = ['loginId','createdDate' , 'otpPurpose', 'sharedkey', 'sessionId','firstName'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  unverifyCount: any;
  Config: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  salesChannelss;
  paymentDetais;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  consumerCount: number;
  user: any;
  type: any;
  UnverifiedAccount: any;
  otpPurposes: any = [];
  acc_id: any = [];
  unverifyaccounts: any;
  unvrifynew: any;
  payvalue: any;
  values: any;
  domain = projectConstants.DOMAIN;
  subdomain = projectConstants.SUBDOMAIN;
  constructor(
    private pagination: PaginationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private unverifiedaccountService: UnverifiedAccountService,
    private commonFilter: CommonfilterService,
    private route: ActivatedRoute,
    private router: Router,
    private commonfilterService: CommonfilterService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog ) {
      this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.Config = res;
        // console.log(this.Config)
        this.otpPurposes = this.Config.userType;
      });
      this.onResize();
    }

  ngOnInit() {
    for (let i in this.data) {
      this.unverifyaccounts = this.data[i];
      if(i === 'payload'){
        this.unvrifynew = JSON.parse(this.unverifyaccounts)
        for (let j in this.unvrifynew){
          this.payvalue = this.unvrifynew[j];
          if( j === 'userProfile'){
            this.values = this.payvalue;
         
          }
        }
       
      }     
  }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
 
  
  onRowClicked(UnverifiedAccount) {
    this.selectedRowIndex = UnverifiedAccount.loginId;
    this.showToolBar = !this.showToolBar;
  }
  showview(){

  }
  getFirstName_Frmpayload(){
    for (let i in this.acc_id) {
        this.unverifyaccounts = this.acc_id[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.firstName;
            return this.values 
            }
          }
         
        }     
    }
  }
  getLastName_Frmpayload(){
    for (let i in this.acc_id) {
        this.unverifyaccounts = this.acc_id[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.lastName;
            return this.values 
            }
          }
         
        }     
    }
  }

}
